import axios from "axios";

const api = axios.create({
    // TODO: "v1.0" não deve ficar aqui na url base, tem que ficar nas chamadas específicas (páginas)
    // para ser possível mudar a versão chamada da api, se necessário, sem alterar a aplicação toda
    // baseURL: 'https://homolog.siscopecriterio.com.br/api/v1.0/'
    // baseURL: 'https://v2-treinamento.siscopecriterio.com.br/api/v1.0/'
    // baseURL: 'https://v2.siscopecriterio.com.br/api/v1.0/'
    baseURL: `${process.env.PUBLIC_URL}${process.env.REACT_APP_API_URL_BASE}/v1.0`
});

export default api;